module.exports = __webpack_public_path__ + "static/media/imagemPD.8ad4427f.png";